import {
  arrayOf,
  bool,
  shape,
  string,
} from 'prop-types';
import commentShape from './comment';

const activityShape = shape({
  eventId: string,
  loadId: string,
  eventType: string,
  initiatorName: string,
  isAutomated: bool,
  note: string,
  reason: string,
  isLiveBounce: bool,
  comments: arrayOf(commentShape),
});

export default activityShape;
